<!--
Locations > building to screen
@author bmk11u, crm4f
-->
<template>
    <div id="contain" class="container">

    <Logo v-if="!authenticated" data-test="logo" />
    <div v-if="!authenticated" class="mb-1" ></div>

    <Nav name="Find a Building or Room" :back="authenticated===true" :step="true"/>

    <FuzzySearchList :authenticated="authenticated===true" :initialLocations="initialLocations" :fullLocations="fullLocations" :aliasLocations="aliasLocations" searchPlaceholder="Search for a building or room..."/>

    <div id="pusher"></div>
    <Footer active="locations" v-if="authenticated"/>
  </div>
</template>

<script setup>
import Logo from '@/components/Logo.vue'
import Footer from '@/components/FooterMenu.vue'
import FuzzySearchList from '@/views/roomfinder/FuzzySearchList.vue'
import { useLocationsCommon } from '@/composables/LocationsCommon.js'
import { useMapCommon } from '../../composables/MapCommon.js'
import { onMounted, ref } from 'vue'

const { toLocation, urlToLocations } = useMapCommon()
const { authenticated } = useLocationsCommon()

const initialLocations = ref(null)
const fullLocations = ref(null)
const aliasLocations = ref(null)

onMounted( async () => {
  // fetch locations data to be searched
  const [aliases, rooms, buildings] = await Promise.all([
    urlToLocations('/map/aliases', alias => toLocation(alias.locId, alias.aliasText)),
    urlToLocations('/map/rooms', room => toLocation(room[0], room[1])),
    urlToLocations('/map/buildings', building => toLocation(building.buildingId, building.buildingName))
  ])

  initialLocations.value = buildings
  fullLocations.value = buildings.concat(rooms)
  aliasLocations.value = aliases
})
</script>
